import slugify from 'react-slugify';

/**
 * Builds the canonical `/programm/<channel>-<title>-<event_id>` link for a showtime.
 *
 * Mirrors the slug format produced by the program guide's `updateSlug`
 * (see pages/programm/[[...slug]].tsx) so that links emitted by listicle cards
 * (e.g. the "Jetzt im TV" section) match the canonical target instead of the
 * bare `/programm/<event_id>` form.
 *
 * The server only uses the trailing `-<event_id>` segment to resolve the entry,
 * so when the channel slug/title are unavailable we fall back to the id-only
 * form, which still resolves correctly.
 */
export const buildProgrammLink = (
  eventId?: string | null,
  channelSlug?: string | null,
  title?: string | null,
): string => {
  if (!eventId) return '/programm';

  const slugBase = slugify([channelSlug, title].filter(Boolean).join('-'));

  return slugBase ? `/programm/${slugBase}-${eventId}` : `/programm/${eventId}`;
};
